/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMore48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M23.588 28.808a.993.993 0 01-.588-.191l-11-8L13.177 19l10.411 7.572L34 19l1.177 1.617-11 8a.998.998 0 01-.589.191z'
      />
    </svg>
  );
}

export default SvgMore48;
